import api from './axios';
import { User } from '../types';

export interface UpdateProfileRequest {
  firstName?: string;
  lastName?: string;
  interfaceLanguage?: string;
}

export interface ChangePasswordRequest {
  currentPassword: string;
  newPassword: string;
}

export class ProfileService {
  async getProfile(): Promise<User> {
    const response = await api.get<User>('/users/profile/me');
    return response.data;
  }

  async updateProfile(data: UpdateProfileRequest): Promise<User> {
    const response = await api.patch<User>('/users/profile/me', data);
    return response.data;
  }

  async changePassword(data: ChangePasswordRequest): Promise<void> {
    await api.patch('/users/profile/me/change-password', data);
  }
}

export const profileService = new ProfileService();
